module.exports = __webpack_public_path__ + "img/intro text_no.7018580d.svg";